export const RESET_DASHBOARD = 'VNT/Dashboard/RESET';
export const SAVE_DASHBOARD = 'VNT/Dashboard/SAVE';
 
export function resetDashboard(name, id) {
  return {
    type: RESET_DASHBOARD,
    name,
    id,
  }
}

export function saveDashboard(name, settings) {
  return {
    type: SAVE_DASHBOARD,
    name,
    settings,
  }
}



// WEBPACK FOOTER //
// ./src/containers/Dashboard/actions.js